import { useState } from 'react';
import { motion } from 'framer-motion';
import { FaDiscord, FaEnvelope, FaInstagram, FaYoutube } from 'react-icons/fa';
import './AdminsSupport.css';


const AdminsSupport = () => {
  const [expandedFaq, setExpandedFaq] = useState(null);

   const founders = [
    { name: 'Allen Ronald', role: 'Founder & CEO', avatar: '/Frierin.jpg', socials : {instagram : "https://www.instagram.com/__allen__r/"} },
    { name: 'Krucifix', role: 'Founder & Head Caster', avatar: '/Guts.jpg',socials : {instagram : "https://www.instagram.com/inkkk.spot/"} },
  { name: 'Griffith', role: 'Founder & Operations Lead', avatar: "/Griffith.jpg",socials : {instagram : "https://www.instagram.com/griffith_smh", youtube :"https://www.youtube.com/@madara_plays_mlbb"} },
    { name: 'Sebastian', role: 'Founder & Senior Streamer',  avatar: '/judeau.jpg',socials : {instagram : "https://www.instagram.com/sebastian_ytsebastian/"} },
    { name: 'Jeff', role: 'Founder & Coach', avatar: '/Kilua.jpg',socials : {instagram : "https://www.instagram.com/casterjeff._/"} },
    { name: 'Aki', role: 'Founder & Operations Lead', avatar: '/Casca.jpg',socials : {instagram : "https://www.instagram.com/aki_likescats/"} },
    { name: 'Nyxira', role: 'Founder & Community Manager', avatar: '/anya.jpg',socials : {instagram : "https://www.instagram.com/nyxiraaaaa/"} },
  ];

  const faqs = [
    {
      question: 'How do I register my team?',
      answer: 'Navigate to the Ashened Cup page and click the "Register Your Team" button. Follow the step-by-step registration process, providing all required information for your manager, IGL, and players.'
    },
    {
      question: 'What are the tournament rules?',
      answer: 'All matches follow official Mobile Legends: Bang Bang 5v5 competitive rules. Teams must adhere to the draft system, no cheating or exploitation, and maintain professional conduct. Full rulebook will be provided upon registration.'
    },
    {
      question: 'What causes disqualification?',
      answer: 'Teams can be disqualified for: cheating, using unauthorized third-party tools, player substitution violations, no-shows, unsportsmanlike conduct, or providing false registration information.'
    },
    {
      question: 'How are schedules determined?',
      answer: 'Match schedules are determined based on group stage seeding and bracket progression. All schedules are posted 48 hours in advance and include timezone information. Check the tournament page regularly for updates.'
    },
    {
      question: 'What if we experience technical issues?',
      answer: 'Contact tournament admins immediately via Discord. For in-match issues, pause the game if possible and notify admins. We have technical support available during all live matches.'
    },
  ];

  const fadeIn = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <div className="admins-support">
      <section className="section admin-hero">
        <div className="container">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={fadeIn}
          >
            <h1 className="page-title">Founders & Admins</h1>
            <p className="page-subtitle">
              Meet the dedicated team behind Liquid Fire Esports
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section founders-section">
        <div className="container">
          <div className="founders-grid">
            {founders.map((founder, index) => (
              <motion.div
                key={index}
                className="founder-card card"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.05, y: -10 }}
              >
                <div className="founder-avatar">
  <img src={founder.avatar} alt={founder.name} />
</div>

                <h3 className="founder-name">{founder.name}</h3>
<p className="founder-role">{founder.role}</p>

<div className="social-links">
  {founder.socials?.instagram && (
    <a
      href={founder.socials.instagram}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaInstagram className="social-icon instagram" />
    </a>
  )}

  {founder.socials?.youtube && (
    <a
      href={founder.socials.youtube}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaYoutube className="social-icon youtube" />
    </a>
  )}
</div>


                <div className={`founder-badge ${founder.gender}`}>
                  {founder.gender === 'female' ? 'Female Founder' : 'Founder'}
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="section support-section">
        <div className="container">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeIn}
          >
            <h2 className="section-title">Contact Support</h2>
            
            <div className="support-options">
              <motion.a
                href="#"
                className="support-card card"
                whileHover={{ scale: 1.05 }}
              >
                <FaDiscord className="support-icon" />
                <h3>Join Our Discord</h3>
                <p>Get instant support from our admin team and community</p>
                <span className="support-link">discord.gg/liquidfire</span>
              </motion.a>

              <motion.a
                href="mailto:support@liquidfireesports.com"
                className="support-card card"
                whileHover={{ scale: 1.05 }}
              >
                <FaEnvelope className="support-icon" />
                <h3>Email Support</h3>
                <p>Send us detailed inquiries and get responses within 24 hours</p>
                <span className="support-link">support@liquidfireesports.com</span>
              </motion.a>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="section faq-section">
        <div className="container">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeIn}
          >
            <h2 className="section-title">Frequently Asked Questions</h2>
            
            <div className="faq-list">
              {faqs.map((faq, index) => (
                <motion.div
                  key={index}
                  className="faq-item"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                >
                  <button
                    className={`faq-question ${expandedFaq === index ? 'active' : ''}`}
                    onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
                  >
                    <span>{faq.question}</span>
                    <span className="faq-icon">{expandedFaq === index ? '−' : '+'}</span>
                  </button>
                  
                  {expandedFaq === index && (
                    <motion.div
                      className="faq-answer"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3 }}
                    >
                      <p>{faq.answer}</p>
                    </motion.div>
                  )}
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default AdminsSupport;
